import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhShipListItem extends SearchModelBase {
    closed: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    shipNo: string = '';
    branch: string = '';
    centerNo: string = '';
    shipToNo: string = '';
    name: string = '';
    shipStatus: string = '';
    shipDate: string | null = null;
    orderDate: string | null = null;
    p: string = '';
    poNo: string = '';
    totalQty: number|null = null;
    trucker: string = '';
    remark: string = '';
    palletRemark: string = '';
    id: number = 0;
    fromShipDate: string | null = null;
    toShipDate: string | null = null;
    fromOrderDate: string | null = null;
    toOrderDate: string | null = null;
    fromTotalQty: number|null = null;
    toTotalQty: number|null = null;
    createdAt: string | null = null;
    status: string = '';
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'INV', width: 35, dataIndex: 'invStat', noNullOrEmptySearch: true,  align: XCol.XAlignType.Center }),
        XCol.Create({ col: 2, text: 'BIL', width: 35, dataIndex: 'billStat', noNullOrEmptySearch: true,  align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'CrDb', width: 35, dataIndex: 'crDbStat', noNullOrEmptySearch: true, align: XCol.XAlignType.Center }),
        // XCol.Create({ col: 1, text: 'V', width: 40, dataIndex: 'isVoid', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 4, text: 'Shipping ID', width: 100, dataIndex: 'shipNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 6, text: 'Customer (WH)', width: 120, dataIndex: 'centerNo'}),
        XCol.Create({ col: 7, text: 'Out Date', width: 75, dataIndex: 'shipDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Order Date', width: 75, dataIndex: 'orderDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 9, text: 'Status', width: 80, dataIndex: 'shipStatus'}),
        XCol.Create({ col: 10, text:  'Paid', width: 40, dataIndex: 'p', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11, text:  'Order #', width: 80, dataIndex: 'poNo'}),
        XCol.Create({ col: 12, text:  'Total Qty', width: 80, dataIndex: 'totalQty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true}),
        XCol.Create({ col: 13, text: 'Ship To', width: 100, dataIndex: 'shipToNo'}),
        XCol.Create({ col: 14, text: 'Carrier', width: 100, dataIndex: 'trucker' }),
        XCol.Create({ col: 15, text: 'Pallet', width: 100, dataIndex: 'palletRemark' }),
        XCol.Create({ col: 16, text: 'Remark', width: 150, dataIndex: 'remark' }),
        XCol.Create({ col: 17, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 18, text: 'Create by', width: 80, dataIndex: 'u1ID' }),
        XCol.Create({ col: 19, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime }),
        XCol.Create({ col: 20, text: 'Update by', width: 80, dataIndex: 'u2ID' }),
        ];

    public static getExportCollection(): XCol.XExportColumn[] {
        // 2023-10-19 jhchoi : Void 컬럼 제거(추후에 사용할 경우 주석 제거)
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: WhShipListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: WhShipListItem[]) {
        return data.map((d: WhShipListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        shipDate: {from: 'fromShipDate', to: 'toShipDate'},
        orderDate: {from: 'fromOrderDate', to: 'toOrderDate'},
        totalQty: {from: 'fromTotalQty', to: 'toTotalQty'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
